@if (validating) {
  <app-auth-validator
    [message]="validationMessage"
    [showErrorMessage]="validationError"
    [showFooterMessage]="showFooterMessage"
    [footerMessage]="validationFooterMessage"
    [showProgressBar]="showProgressBar"
    [showInput]="showInput"
    (submitClick)="activateCode($event)"
  ></app-auth-validator>
}

@if (!validating) {
  <router-outlet ></router-outlet>
}